export const marketoForms = {
  // Done
  ORDER_PROPANE_FORM: {
    url: 'https://app-ab05.marketo.com',
    marketoFormID: 7828,
    formElementID: 'mktoForm_7828',
  },
  // Done
  ORDER_HOME_HEATING_OIL_FORM: {
    url: 'https://app-ab05.marketo.com',
    marketoFormID: 7827,
    formElementID: 'mktoForm_7827',
  },
  // Done
  SIGN_UP_TODAY: {
    url: 'https://app-ab05.marketo.com',
    marketoFormID: 7838,
    formElementID: 'mktoForm_7838',
  },
  // Done
  ENROLL_TODAY: {
    url: 'https://app-ab05.marketo.com',
    marketoFormID: 7852,
    formElementID: 'mktoForm_7852',
  },
  // Done
  REGISTER_NOW: {
    url: 'https://app-ab05.marketo.com',
    marketoFormID: 7859,
    formElementID: 'mktoForm_7859',
  },
  // Done
  REFFERAL_PROGRAM: {
    url: 'https://app-ab05.marketo.com',
    marketoFormID: 7867,
    formElementID: 'mktoForm_7867',
  },
  // Done
  ORDER_FUEL_ONLINE_COMMERCIAL: {
    url: 'https://app-ab05.marketo.com',
    marketoFormID: 7829,
    formElementID: 'mktoForm_7829',
  },
  // Done
  EBILLING_REGISTER_NOW: {
    url: 'https://app-ab05.marketo.com',
    marketoFormID: 7860,
    formElementID: 'mktoForm_7860',
  },
  // Done
  ONSITE_REFUELLING: {
    url: 'https://app-ab05.marketo.com',
    marketoFormID: 7866,
    formElementID: 'mktoForm_7866',
  },
  // Done
  PIPELINE_COMMERCIAL: {
    url: 'https://app-ab05.marketo.com',
    marketoFormID: 7904,
    formElementID: 'mktoForm_7904',
  },
  // Done
  CONTACT_US_TODAY_ABOUT_FCC: {
    url: 'https://app-ab05.marketo.com',
    marketoFormID: 7861,
    formElementID: 'mktoForm_7861',
  },
  // Done
  REQUEST_CALLBACK: {
    url: 'https://app-ab05.marketo.com',
    marketoFormID: 7835,
    formElementID: 'mktoForm_7835',
  },
  // Done
  CONTACT_US_DEFAULT: {
    url: 'https://app-ab05.marketo.com',
    marketoFormID: 1068,
    formElementID: 'mktoForm_1068',
  },
  // Done
  CONTACT_US_COMMERCIAL: {
    url: 'https://app-ab05.marketo.com',
    marketoFormID: 3863,
    formElementID: 'mktoForm_3863',
  },
  CONTACT_US_DEFAULT: {
    url: 'https://app-ab05.marketo.com',
    marketoFormID: 1068,
    formElementID: 'mktoForm_1068',
  },
  OPEN_ACCOUNT_ON_CALL: {
    url: 'https://app-ab05.marketo.com',
    marketoFormID: 8053,
    formElementID: 'mktoForm_8053',
  },
  CONTACT_US_TODAY_LOCATION: {
    url: 'https://app-ab05.marketo.com',
    marketoFormID: 7854,
    formElementID: 'mktoForm_7854',
  },
  SLP_PROPANE: {
    url: 'https://app-ab05.marketo.com',
    marketoFormID: 8001,
    formElementID: 'mktoForm_8001',
  },
  SLP_WELCOME: {
    url: 'https://app-ab05.marketo.com',
    marketoFormID: 7270,
    formElementID: 'mktoForm_7270',
  },
  SLP_FFF_PROMOTION: {
    url: 'https://app-ab05.marketo.com',
    marketoFormID: 7544,
    formElementID: 'mktoForm_7544',
  }
};

export const MARKETO_FORMS_CONSTANTS = {
  ORDER_PROPANE_FORM: 'ORDER_PROPANE_FORM',
  ORDER_HOME_HEATING_OIL_FORM: 'ORDER_HOME_HEATING_OIL_FORM',
  SIGN_UP_TODAY: 'SIGN_UP_TODAY',
  ENROLL_TODAY: 'ENROLL_TODAY',
  REGISTER_NOW: 'REGISTER_NOW',
  REFFERAL_PROGRAM: 'REFFERAL_PROGRAM',
  ORDER_FUEL_ONLINE_COMMERCIAL: 'ORDER_FUEL_ONLINE_COMMERCIAL',
  EBILLING_REGISTER_NOW: 'EBILLING_REGISTER_NOW',
  ONSITE_REFUELLING: 'ONSITE_REFUELLING',
  PIPELINE_COMMERCIAL: 'PIPELINE_COMMERCIAL',
  CONTACT_US_TODAY_ABOUT_FCC: 'CONTACT_US_TODAY_ABOUT_FCC',
  REQUEST_CALLBACK: 'REQUEST_CALLBACK',
  CONTACT_US_TODAY_LOCATION: 'CONTACT_US_TODAY_LOCATION',
  CONTACT_US_DEFAULT: 'CONTACT_US_DEFAULT',
  CONTACT_US_COMMERCIAL: 'CONTACT_US_COMMERCIAL',
  OPEN_ACCOUNT_ON_CALL: 'OPEN_ACCOUNT_ON_CALL',
  SLP_FFF_PROMOTION: 'SLP_FFF_PROMOTION'
};
export const marketoId = '452-UJJ-105';
